import React, { FC } from 'react'

import { Flex } from '../../new/core-components/box'

type Props = {
  content?: React.ReactNode
}

export const StartContent: FC<Props> = ({ content }: Props) => {
  if (!content) {
    return null
  }

  return (
    <Flex h='100%' alignItems='center' justifyContent='center' ml={4}>
      {content}
    </Flex>
  )
}
